// extracted by mini-css-extract-plugin
export var closed = "MainNav-module--closed--b6025";
export var container = "MainNav-module--container--89633";
export var list = "MainNav-module--list--4d797";
export var menuToggle = "MainNav-module--menuToggle--ff8d0";
export var onlyMobile = "MainNav-module--onlyMobile--6426b";
export var open = "MainNav-module--open--c72f3";